import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-socket-io', 'IconBrandSocketIo', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M11 11h1l3 -4z', key: 'svg-1' }],
  ['path', { d: 'M12 13h1l-4 4z', key: 'svg-2' }],
]);
